import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {useTheme, useMediaQuery } from "@mui/material";

import TestimonialList from "../../../common/components/testimonials/TestimonialList";
import { testimonialData } from "../list/utils";

import { dphiBlue,neutral } from "../../../common/config/colors";

const Testimonials = () => {
  const theme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <TestimonialList
      testimonialData={testimonialData}
      titleProps={{
        children: "Let’s see what our learners are saying",
        variant: "h3",
        align: "center",
        sx: {
          color: neutral["A500"],
          fontWeight: 700,
          [theme.breakpoints.down("md")]: {
            fontSize: 24,
          },
        },
      }}
      boxProps={{ bgcolor: dphiBlue["A100"], py: { xs: 6, md: 12 } }}
    >
      <>
        {!isDownSm && (
          <Box textAlign="center" pt={8}>
            <Typography variant="subtitle1" pb={2} color={neutral["A500"]}>
              Harness the power of community learning. Together, we can make it
              happen!
            </Typography>
            <Typography color= {neutral["A500"]} variant="subtitle1" fontWeight={700}>
              #LetsMakeitHappen
            </Typography>
          </Box>
        )}
      </>
    </TestimonialList>
  );
};

export default Testimonials;
